import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ScaleModal = ({ show, title, message, onConfirm, onCancel, confirmText, cancelText }) => {
    const [scale, setScale] = useState(100);
    const [isInvalid, setIsInvalid] = useState(false);

    useEffect(() => {
        if (show) {
            // Reset scale and validation when modal is shown
            setScale(100);
            setIsInvalid(false);
        }
    }, [show]);

    const handleScaleChange = (e) => {
        const value = e.target.value;
        if (value === '') {
            setScale('');
            setIsInvalid(true);
            return;
        }
        
        const numValue = parseInt(value, 10);
        setScale(numValue);
        setIsInvalid(numValue < 50 || numValue > 150);
    };

    const handleConfirm = () => {
        if (!isInvalid) {
            onConfirm(scale);
        }
    };

    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{message}</p>
                <Form.Group>
                    <Form.Label>Масштаб (%)</Form.Label>
                    <Form.Control
                        type="number"
                        value={scale}
                        onChange={handleScaleChange}
                        min="50"
                        max="150"
                        step="1"
                        isInvalid={isInvalid}
                        autoFocus
                    />
                    <Form.Control.Feedback type="invalid">
                        Пожалуйста, введите значение от 50 до 150.
                    </Form.Control.Feedback>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                {cancelText && onCancel && (
                    <Button variant="secondary" onClick={onCancel}>
                        {cancelText}
                    </Button>
                )}
                {confirmText && onConfirm && (
                    <Button variant="primary" onClick={handleConfirm} disabled={isInvalid}>
                        {confirmText}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ScaleModal;